module.exports = __webpack_public_path__ + "img/maestro.eb424c97.png";